import styled from 'styled-components'

import { helpers } from 'styles'

import { Button } from './Button'

type Props = {
	isDisabled?: boolean
}

export const Subtitle = styled.div<Props>`
	font-size: ${helpers.font.size.baseSmall};
	color: ${({ theme, isDisabled }) => (isDisabled ? theme.color.linkDisabledSubtitle : theme.color.text)};
	font-weight: 400;
	text-decoration: none;

	${Button}:disabled & {
		opacity: 0.6;
	}
`
